module.exports = __webpack_public_path__ + "img/yeosu_gallery2.376baf06.jpg";